var module = angular.module('sdCompanyProfileModule');

module.controller('SDCompanyProfileController', ["$scope", "$resource", "$attrs", "$location", "$cookies", "$http", "$injector", "$window", "$uibModal", "$sce", "$timeout", "ProfileStrength", "TranslationService", function ($scope, $resource, $attrs, $location, $cookies, $http, $injector, $window, $uibModal, $sce, $timeout, ProfileStrength, TranslationService) {
    var PROFILE_BOOSTER_AB_TEST = 'free_trial_experience__b';
    $scope.loadingDone = false;
    $scope.photosUploadLimit = 50;
    $scope.companyProfileNav = {active: 'about-us'};
    $scope.data = {
        activeSlide: 0,
        profile: null,
        reviewsPage: 1,
        loadingReviews: false,
        map: {
            urlLarge: '',
            urlSmall: '',
            actionUrl: '',
            show: false,
            zoomLarge: 14,
            zoomSmall: 15,
        }
    };
    var businessPromotionCookie = $cookies.get('collapseBusinessPromotion');
    var expiryDate = new Date();

    var Profile = $resource('/account/' + $attrs.sdCompany + '/profile_full.json');
    var Review = $resource('/account/' + $attrs.sdCompany + '/reviews.json');

    activate();
    function activate() {
        getProfile();
        setUpCarousel();

        if(angular.isDefined(businessPromotionCookie)) {
            $scope.collapseBusinessPromotion = (businessPromotionCookie == 'true');
        } else {
            $scope.collapseBusinessPromotion = false;
        }
        expiryDate.setDate(expiryDate.getDate() + 365);
        $scope.toggleBusinessPromotion = function (collapseBusinessPromotion, name) {
            $scope[name] = !$scope[name];
            $cookies.put(name, $scope[name], { 'expires': expiryDate });
        };
        initAnonymousReviews();
    }

    $scope.onPhotoDeleted = onPhotoDeleted;
    $scope.goToCompanyWebsite = goToCompanyWebsite;

    $scope.loadMoreReviews = function () {
        $scope.data.loadingReviews = true;
        $scope.data.reviewsPage++;
        Review.query({page: $scope.data.reviewsPage}).$promise.then(function (reviews) {
            for (var key = 0; key < reviews.length; key++) {
                var review = reviews[key];
                $scope.data.profile.reviews.push(review);
            }
            $scope.data.loadingReviews = false;
        });
    };

    /**
     * The reviews section has two variants. Both are hidden until company.json resolved, otherwise the
     * legacy variant would flash before the flags of an eligible company are known. The booster variant
     * carries owner-only actions, so the public render always falls back to the legacy variant.
     */
    $scope.isCompanyResolved = function () {
        return !!$scope.company && true === $scope.company.$resolved;
    };

    $scope.isProfileBoosterEligible = function () {
        return $scope.isCompanyResolved()
            && !$scope.editingDisabled
            && $scope.company.abTest === PROFILE_BOOSTER_AB_TEST;
    };

    /**
     * Google figures only count towards the summary once the account is connected. The connected check
     * is repeated from GoogleReviewsController, which runs in a child scope that the summary sits
     * outside of.
     */
    function connectedGoogleReviews() {
        var google = $scope.data.profile && $scope.data.profile.googleReviews;

        if (!google || google.isConnected !== true) {
            return {rating: 0, count: 0};
        }

        return {rating: google.rating || 0, count: google.userRatingCount || 0};
    }

    $scope.getCombinedReviewsAmount = function () {
        if (!$scope.data.profile) {
            return 0;
        }

        return ($scope.data.profile.reviewsAmount || 0) + connectedGoogleReviews().count;
    };

    /**
     * Blends the consumer and Google averages, each weighted by its own review count, so the summary
     * badge reflects both sources once a Google account is connected. Both averages are stored out of
     * 5 (see the sdGoogleStars directive), so the result stays out of 5 for getRating() and the
     * template's * 2 display, matching the spec's out-of-10 formula after that doubling.
     */
    $scope.getCombinedRating = function () {
        var profile = $scope.data.profile;

        if (!profile) {
            return null;
        }

        var google = connectedGoogleReviews();
        var consumerCount = profile.reviewsAmount || 0;
        var totalCount = consumerCount + google.count;

        if (totalCount === 0) {
            return null;
        }

        return (((profile.rating || 0) * consumerCount) + (google.rating * google.count)) / totalCount;
    };

    $scope.onCompareQuotes = function () {
        window.location = '/';
    };

    /**
     * todo: extract the function to one place and reuse everywhere
     * When changing the ratings here, you probably also have to adjust them in the following files:
     *  - angular/projects/self-service/src/app/projects/review/block/rating-label.component.ts: getRatingColorClass
     *  - symfony-standard/app_b2c/src/B2cRedesignBundle/Resources/private/controllers/review-controller.js: $scope.getRatingState
     *  - angular/projects/self-service/src/app/projects/review/category-score-rating/category-score-rating.component.ts: getRatingClass
     */
    $scope.getRating = function (rating) {
        if (!rating) {
            return 'company-rating-unknown';
        }
        if (rating <= 1.25) {
            return 'company-rating-very-bad';
        }
        if (rating <= 2.8) {
            return 'company-rating-bad';
        }
        if (rating <= 3) {
            return 'company-rating-medium';
        }
        if (rating <= 4) {
            return 'company-rating-good';
        }
        if (rating <= 5) {
            return 'company-rating-very-good';
        }
    };

    $scope.getLogoBackgroundClass = function(logo) {
        return logo && logo.url ? 'bg-white' : 'bg-gray-light logo-image-placeholder';
    };

    var i = 0;
    function loadQueue(queue) {
        var target = queue.shift();
        var downloadingImage = new Image();
        downloadingImage.onload = function () {
            $scope.$apply(function () {
                $scope.data.profile.photos[i].url = target.originalUrl;

                if (queue.length > 0) {
                    i++;
                    loadQueue(queue);
                }
            });
        };
        downloadingImage.src = target.originalUrl;
    }

    $scope.updateProjectTable = function () {
        $scope.projectTableParams.reload();
    };

    $scope.$watch('collapseBusinessPromotion', function (newValue) {
        if (newValue == true) {
            $scope.folded = 'folded';
        } else {
            $scope.folded = '';
        }
    });

    $scope.$watchGroup(['loadingDone', 'data.profile.geocodeAddress'], function(newValues) {
        if (true === newValues[0] && newValues[1]) {
            $scope.data.map.show = true;
        }
    });

    $scope.contactDetails = function () {
        $uibModal.open({
            templateUrl: '/account/tpl/contact-details-modal.html',
            scope: $scope,
            backdrop: 'static',
            keyboard: false,
            size: 'md',
            windowClass: 'sd-modal contact-details-modal'
        });
    };

    $scope.showShareNotification = function() {
        $scope.notices.shareSuccess = true;
    };

    function onPhotoDeleted(deletedPhoto) {
        const index = $scope.data.profile.photos.indexOf(deletedPhoto);
        const length = $scope.data.profile.photos.length;
        if (index === length - 1) {
            $scope.data.activeSlide = 0;
        }
        $scope.data.profile.photos = $scope.data.profile.photos.filter(function (photo) {
            return photo.name !== deletedPhoto.name;
        });
        $scope.$root.$broadcast('profile:updated');
    }

    function getProfile() {
        Profile.get().$promise.then(function (data) {
            // We don't want to load all photos at once so load them staggered
            var queue = [];
            angular.forEach(data.photos, function (value, key) {
                value.originalUrl = value.url;
                value.url = '/build/img/company-profile/loader.gif';
                queue[key] = value;
            });

            if (queue.length > 0) {
                loadQueue(queue);
            }

            // Apply loader.gif to logo
            if (data.logo !== null) {
                var originalUrl = data.logo.url;
                data.logo.url = '/build/img/company-profile/loader.gif';
                var downloadingImage = new Image();
                downloadingImage.onload = function () {
                    $scope.$apply(function () {
                        $scope.data.profile.logo.url = originalUrl;
                    });
                };
                downloadingImage.src = originalUrl;
            }
            $scope.data.profile = data;

            if (data.geocodeAddress) {
                $scope.addressArray = data.geocodeAddress.split(',');
                var mapStyleConfig = '&style=feature:administrative.land_parcel%7Celement:labels%7Cvisibility:off &style=feature:poi%7Celement:labels.text%7Cvisibility:off &style=feature:poi.business%7Cvisibility:off &style=feature:poi.park%7Celement:labels.text%7Cvisibility:off &style=feature:road.local%7Celement:labels%7Cvisibility:off &style=feature:transit%7Celement:labels.icon%7Cvisibility:off';
                var formattedAddress = '';

                if (data.coordinates) {
                    formattedAddress = data.coordinates.latitude + ',' + data.coordinates.longitude;
                } else {
                    formattedAddress = data.geocodeAddress.replace(/ /g,'+');
                }

                $scope.data.map.urlLarge = `https://maps.googleapis.com/maps/api/staticmap
            ?center=${formattedAddress}&zoom=${$scope.data.map.zoomLarge}&size=640x400&scale=2&maptype=roadmap&format=jpg
            &markers=${formattedAddress}
            &key=${$window.google_api_key}${mapStyleConfig}`.replace(/ /g,'');

                $scope.data.map.urlSmall = `https://maps.googleapis.com/maps/api/staticmap
            ?center=${formattedAddress}&zoom=${$scope.data.map.zoomSmall}&size=546x342&scale=2&maptype=roadmap&format=jpg
            &markers=${formattedAddress}
            &key=${$window.google_api_key}${mapStyleConfig}`.replace(/ /g,'');

                $scope.data.map.actionUrl = `https://www.google.${$attrs.sdCountryTld}/maps/search/${formattedAddress}`;
            }

            $scope.loadingDone = true;
            if ($location.hash() !== '') {
                for (var key in $scope.data.profile.reviews) {
                    var review = $scope.data.profile.reviews[key];
                    if ($location.hash() === 'review-' + review.id) {
                        review.highlight = true;
                        break;
                    }
                }
            }

            handleAnchorNavigation();
        });
    }

    function handleAnchorNavigation() {
        var hash = $window.location.hash ? $window.location.hash.replace('#', '') : '';
        if (!hash) return;

        $timeout(function () {
            var el = document.getElementById(hash);
            if (el) el.scrollIntoView({ behavior: 'smooth' });

            if ($scope.editingDisabled) return;

            var action = anchorActionMap[hash];
            if (!action) return;

            $timeout(function () {
                if (typeof action === 'function') {
                    action();
                } else {
                    var editableEl = document.querySelector('[editable="' + action + '"]');
                    if (editableEl) editableEl.click();
                }
            }, 800);
        });
    }

    function goToCompanyWebsite() {
        if ($scope.data.profile.website) {
            $window.location = $scope.data.profile.website;
        }
    }

    function setUpCarousel() {
        $('#photoCarousel').on('slid.bs.carousel', function (event) {
            $scope.data.activeSlide = event.to;
            $scope.$digest();
        });
    }

    function initAnonymousReviews() {
        $scope.anonymousPopoverContent = $sce.trustAsHtml($('#anonymous-popup').html());
    }

    // ── Profile Strength Panel ──
    $scope.showProfileStrength = false;
    $scope.strengthExpanded = true;
    $scope.strengthData = null;
    $scope.strengthSections = {};

    $scope.sectionIcons = {
        photos: 'upload-photo-green',
        reviews: 'import-reviews-green',
        about: 'about-company-green',
        logo: 'company-logo-green',
        qa: 'qa-section-green',
        company_facts: 'company-facts-green',
        company_info: 'company-info-green'
    };

    $scope.sectionLabels = {
        logo: TranslationService.trans('profile_score.panel.logo.section_title'),
        photos: TranslationService.trans('profile_score.panel.photos.section_title'),
        reviews: TranslationService.trans('profile_score.panel.reviews.section_title'),
        about: TranslationService.trans('profile_score.panel.about.section_title'),
        qa: TranslationService.trans('profile_score.panel.qa.section_title'),
        company_facts: TranslationService.trans('profile_score.panel.company_facts.section_title'),
        company_info: TranslationService.trans('profile_score.panel.company_info.section_title')
    };

    $scope.toggleStrengthPanel = function () {
        $scope.strengthExpanded = !$scope.strengthExpanded;
    };

    var sectionActions = {
        logo: {
            scrollTo: null,
            action: function () {
                $scope.openAddPhotoDialog(
                    $scope.logoUploadSuccessCallback,
                    200, 200, $scope.data.profile, true
                );
            }
        },
        photos: { scrollTo: 'project-photos', action: null },
        reviews: { scrollTo: 'reviews', action: null },
        about: { scrollTo: 'about-us', action: null },
        qa: { scrollTo: 'qa', action: null },
        company_facts: { scrollTo: 'company-facts', action: null },
        company_info: { scrollTo: 'company-info', action: null }
    };

    var anchorActionMap = {
        'logo': function () {
            $scope.openAddPhotoDialog(
                $scope.logoUploadSuccessCallback,
                200, 200, $scope.data.profile, true
            );
        },
        'project-photos': function () {
            $scope.openAddPhotoDialog(
                $scope.photoUploadSuccessCallback,
                $scope.cropperWidth, $scope.cropperHeight, $scope.data.profile
            );
        },
        'about-us': 'about',
        'qa': 'qa',
        'company-facts': 'facts',
        'company-info': 'contact'
    };

    var sectionTrackingIds = {
        logo: 'add__your_logo',
        reviews: 'add__add_reviews',
        photos: 'add__upload_project_photo',
        about: 'add__about_the_company',
        qa: 'add__q_and_a',
        company_facts: 'add__company_facts',
        company_info: 'add__company_info'
    };

    $scope.goToSection = function (key) {
        var config = sectionActions[key];
        if (!config) return;

        var trackingId = sectionTrackingIds[key];
        if (trackingId) {
            try {
                window.SelfServiceGATracker.sendButtonClickEvent(trackingId, $scope.company ? $scope.company.id : null);
            } catch (e) { /* tracker not loaded */ }
        }

        if (config.scrollTo) {
            var el = document.getElementById(config.scrollTo);
            if (el) el.scrollIntoView({ behavior: 'smooth' });
        }

        if (config.action && typeof config.action === 'string') {
            var editableEl = document.querySelector('[editable="' + config.action + '"]');
            if (editableEl) editableEl.click();
        } else if (typeof config.action === 'function') {
            config.action();
        }
    };

    var strengthRequestGeneration = 0;

    function loadProfileStrength() {
        if (!$scope.company ||
            $scope.company.abTest !== 'free_trial_experience__b') {
            $scope.showProfileStrength = false;
            return;
        }

        var generation = ++strengthRequestGeneration;

        ProfileStrength.getBreakdown()
            .then(function (response) {
                if (generation !== strengthRequestGeneration) return;

                $scope.strengthData = response.data;
                $scope.showProfileStrength = true;
                $scope.strengthExpanded = true;

                $scope.strengthSections = {};
                response.data.sections.forEach(function (s) {
                    $scope.strengthSections[s.key] = s;
                });
            }, function () {
                if (generation !== strengthRequestGeneration) return;

                $scope.showProfileStrength = false;
            });
    }

    $scope.$watch('company.abTest', function (val) {
        if (val !== undefined) {
            loadProfileStrength();
        }
    });

    $scope.$on('profile:updated', function () {
        loadProfileStrength();
    });
}]);

module.directive('sdPublicProfileStars', function () {
    return {
        scope: {
            getRating: '=',
            rating: '=sdRating',
            starSize: '=',
        },
        link: function(scope, element, attrs) {
            scope.size = attrs.starSize || 'sm';
        },
        template: '' +
            '<div class="rating-star star-{{size}}"' +
            '     ng-repeat="i in [1,3,5.5,7,8.5]"' +
            '     ng-class="i <= rating*2 ? getRating(rating) : \'\'">\n' +
            '    <div class="rating background-white">' +
            '       <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" width="100%" height="100%" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="2 2 20 20"><path d="M16.23 18L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18zM11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2z" fill="currentColor"/></svg>\n' +
            '    </div>' +
            '</div>'
    };
});
